import {ChangeEvent, FC} from 'react';
import Checkbox from '@mui/material/Checkbox';
import FormControlLabel from '@mui/material/FormControlLabel';

type StuckItemProps = {
  value: string,
  name: string,
  label: string,
  disabled: boolean,
  checked: boolean,
  onChange: (e: ChangeEvent<HTMLInputElement>) => void
}

const StuckItem: FC<StuckItemProps> = ({
  name, label, value, disabled, checked, onChange
}) => {
  return (
    <li>
      <FormControlLabel
        control={(
          <Checkbox
            size="small"
            id={name}
            name={name}
            checked={checked}
            disabled={disabled}
            value={value}
            onChange={onChange}
          />
        )}
        label={label}
      />
    </li>
  );
};

export default StuckItem;
